import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useRuntimeConfig } from '#app';
import { usePageStore } from '~/stores/pageStore';

export const useMenuStore = defineStore('menu', () => {
  const items = ref([]);
  const footerItems = ref([]);
  const isLoading = ref(false);
  const error = ref(null);

  async function fetchMenus() {

    isLoading.value = true;
    error.value = null;
    const config = useRuntimeConfig();
    const pageStore = usePageStore();

    try {
      // Fetch primary menu
      const primaryMenuUrl = `${config.public.wordpressApiUrl}/wp-json/wp/v2/menu/primary`;
      const primaryMenuResponse = await fetch(primaryMenuUrl);
      if (!primaryMenuResponse.ok) {
        throw new Error('Failed to fetch primary menu');
      }
      const primaryMenuData = await primaryMenuResponse.json();
      
      if (primaryMenuData.length > 0) {
        items.value = primaryMenuData.map(item => ({
          ...item,
          path: item.url.replace(config.public.wordpressApiUrl.replace(/\/$/, '') + '/', '') || '/'
        }));
      }

      // Fetch footer menu
      const footerMenuUrl = `${config.public.wordpressApiUrl}/wp-json/wp/v2/menu/5`;
      const footerMenuResponse = await fetch(footerMenuUrl);
      if (!footerMenuResponse.ok) {
        throw new Error('Failed to fetch footer menu');
      }
      const footerMenuData = await footerMenuResponse.json();
      if (footerMenuData.length > 0) {
        footerItems.value = footerMenuData.map(item => ({
          ...item,
          path: item.url.replace(config.public.wordpressApiUrl.replace(/\/$/, '') + '/', '') || '/'
        }));
        pageStore.setFooterPages(footerItems.value);
      }

    } catch (e) {
      error.value = e.message;
    } finally {
      isLoading.value = false;
    }
  }

  return { items, footerItems, isLoading, error, fetchMenus };
});